// Vuelve a la sección "Cómo donar" para que el mensaje de éxito quede a la vista,
// incluso si el usuario se desplazó mientras completaba el formulario.
function scrollToComo() {
  document.getElementById("como")?.scrollIntoView({ behavior: "smooth", block: "start" });
  window.location.hash = "como";
}

export { scrollToComo };
